import styled from 'styled-components';

export const CookieWrapper = styled.div`
	position: fixed;

	width: 100vw;
	height: fit-content;
	padding: 20px 0;
	bottom: 0;
	background: linear-gradient(91deg, #4f17aa 1.48%, #48068a 99.24%);
	z-index: 999999;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 16px;

	@media (min-width: 600px) {
		height: fit-content;
		padding: 20px;
		box-sizing: border-box;
		justify-content: space-evenly;
		overflow: hidden;
	}
`;

export const TopWrapper = styled.div`
	color: #fff;
	text-align: center;
	font-family: 'Nunito Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	margin-bottom: 10px;
`;

export const MiddleText = styled.div`
	color: #fff;
	text-align: center;
	font-family: 'Lato';
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 120%; /* 14.4px */
	max-width: 700px;

	a {
		color: #fff;
	}

	@media (max-width: 600px) {
		max-width: 90%;
		text-align: left;
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	gap: 38px;

	@media (max-width: 600px) {
		gap: 10px;
	}
`;

export const ButtonDenied = styled.button`
	display: inline-flex;
	padding: 8px 20px;
	justify-content: center;
	align-items: center;
	gap: 10px;

	border-radius: 100px;
	border: 2px solid #ece5f2;
	background-color: transparent;
	color: #ece5f2;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.48px;
	text-transform: uppercase;
	cursor: pointer;
`;

export const ButtonAccept = styled.button`
	display: inline-flex;
	padding: 8px 20px;
	justify-content: center;
	align-items: center;
	gap: 10px;

	border: none;
	border-radius: 100px;
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.48px;
	text-transform: uppercase;
	background-color: white;
	cursor: pointer;
`;

export const FlexTop = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	@media (min-width: 600px) {
		gap: 10px;
	}
`;
